module.exports = __webpack_public_path__ + "img/128x128_diamond_carrier.a2631595.svg";